import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import {
  ILiveStreamJob,
} from './interfaces';

const basePath = '/livestream';

/* eslint-disable implicit-arrow-linebreak */
export const getLivestreamJobs = (date: Date = new Date()): AxiosPromise<IApiResponse<Array<ILiveStreamJob>>> => {
  const dateString = date.toISOString().split('T')[0];
  return vaultApi.getInstance().get(`${basePath}/getJobs?date=${dateString}`);
};
